import React from 'react';
import { AutoLoginLayout } from 'common/auth/modules/pods/login/auto';
import { AutoLoginLoggedForm } from 'common/auth/modules/pods/login/auto';
export const AutoLoginLoggedScene = () => {
    return (React.createElement(AutoLoginLayout, null,
        React.createElement(AutoLoginLoggedForm, null)));
};
